import React from "react";
import { GridCell, gridConstants, GridContainer, GridFlexSpacer } from "../Grid";

interface LayoutSmallProps {
    children?: React.ReactNode;
    className?: string;
}

export const LayoutSmall: React.FC<LayoutSmallProps> = ({ children, className }: LayoutSmallProps) => {
    return (
        <GridContainer>
            <GridFlexSpacer/>
            <GridCell
                className={className}
                medium_columns={gridConstants.column.EIGHT}
                large_columns={gridConstants.column.SIX}
            >
                {children}
            </GridCell>
            <GridFlexSpacer/>
        </GridContainer>
    );
};
